// Must stay first: configures logging before any other module is evaluated.
import './setup-logging';

import { bootstrapApplication } from '@angular/platform-browser';
import { createLogger } from '@hunting-nature/shared-core/logging';
import { APP_ICONS } from '@hunting-nature/shared-ui/helper/icon-registry.const';
import { addIcons } from 'ionicons';
import { cameraOutline, imagesOutline } from 'ionicons/icons';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import '@angular/common/locales/global/de';
// Import cache management utilities for console access
import './app/shared/utils/cache-management.utils';
import { installFetchCache } from './app/shared/utils/fetch-cache.utils';

// Register all icons globally from centralized registry
addIcons({
  'camera-outline': cameraOutline,
  'images-outline': imagesOutline,
  ...APP_ICONS,
});

const log = createLogger('Main');

log.info('Starting application', {
  environment: environment.environment,
  production: environment.production,
  app: environment.appName,
  appId: environment.appId,
  version: environment.version,
});

installFetchCache();

bootstrapApplication(AppComponent, appConfig).catch((error: unknown) => log.error('Failed to bootstrap application', { error }));
